const PerforamanceReportTypes = {
  PERFORMANCE_REPORT_FETCH_START: "performance_report_fetch_start",
  PERFORMANCE_REPORT_FETCH_SUCCESS: "performance_report_fetch_success",
  PERFORMANCE_REPORT_FETCH_FAILURE: "performance_report_fetch_failure",
  PERFORMANCE_REPORT_FETCH_RESET_START: "performance_report_fetch_Reset_start",
  PERFORMANCE_REPORT_FETCH_RESPONSE_CHANGED: "performance_report_fetch_changed",

  //*************************PERFORMANE REPORT DATE WISE LIST START *********************//

  //*************************PERFORMANE REPORT DATE WISE LIST START *********************//
  PERFORMANCE_REPORT_EXPORT_START: "performance_report_export_start",
  PERFORMANCE_REPORT_EXPORT_SUCCESS: "performance_report_export_success",
  PERFORMANCE_REPORT_EXPORT_FAILURE: "performance_report_export_failure",
  PERFORMANCE_REPORT_EXPORT_RESET_START:
    "performance_report_export_reset_start",
  PERFORMANCE_REPORT_EXPORT_CHANGED: "performance_report_export_changed",
};
export default PerforamanceReportTypes;
